import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import styled from 'styled-components';

import Box from '@neta/Box';
import Flex from '@neta/Flex';
import Text from '@neta/Text';
import { colors } from '@styles/theme';

const Link = styled.a``;

const DropdownFlex = styled(Flex)`
  svg {
    width: 24px;
    height: 24px;
  }
  svg,
  g {
    fill: ${colors.grayscale.black};
  }
  &:hover {
    background: ${colors.grayscale.lightGray};
  }
`;
export class DropdownMenuItem extends React.Component {
  render() {
    const { children, href, icon, onClick } = this.props;
    const row = (
      <DropdownFlex
        onClick={onClick}
        alignItems="center"
        py={2}
        px={3}
        color={colors.grayscale.black}
      >
        <Box>{icon}</Box>
        <Text.body pl={icon ? 3 : 0} pb="3px" fontWeight="regular">
          {children}
        </Text.body>
      </DropdownFlex>
    );
    return href ? (
      <Link href={href} onClick={onClick}>
        {row}
      </Link>
    ) : (
      row
    );
  }
}

const hideBodyProps = {
  bg: 'transparent',
  border: 'none',
  py: 0
};

export default class Dropdown extends React.Component {
  state = { isOpen: !!this.props.isOpen };

  toggleOpen = e => {
    e && e.stopPropagation();
    this.setState(({ isOpen }) => {
      return { isOpen: !isOpen };
    });
  };

  render() {
    const { activator, body, bodyProps = {}, hideBody } = this.props;
    const { isOpen } = this.state;
    const mergedBodyProps = hideBody ? { ...hideBodyProps, ...bodyProps } : bodyProps;

    return (
      <OutsideClickHandler onOutsideClick={() => this.setState({ isOpen: false })}>
        <Box css="cursor: pointer;">
          {React.cloneElement(activator, { onClick: this.toggleOpen })}
          {isOpen && (
            <Box
              position="absolute"
              mt={2}
              py={3}
              top="100%"
              bg="grayscale.white"
              border="divider"
              borderRadius="4px"
              zIndex="20"
              {...mergedBodyProps}
            >
              {typeof body === 'function'
                ? body({ closeDropdown: this.toggleOpen })
                : body}
            </Box>
          )}
        </Box>
      </OutsideClickHandler>
    );
  }
}
